/**
 * Created by rorschach on 2018/5/25.
 */
import history from "../router/history";
import urlUtils from "url";
import querystring from "querystring";
import * as consts from "../consts/consts";
// import config from "../consts/config";
// import { STORAGE_KEYS } from "../consts/consts";
import { Base64 } from "js-base64";
import { noop } from "lodash";
import xyStorage from "../utils/xyStorage";
// import locale from "moment/locale/zh-cn";
// import * as allUrls from "../router/allUrls";
import qs from "qs";
import { Modal, Toast } from "xyui";
import { func } from "prop-types";
/* 转换xxx-form */
function qsStringify(data) {
  return qs.stringify(data);
}

function mathRandom(random) {
  const n1 = Math.round(Math.random() * 100); //获取100之内的任意一个整数；
  let num = 0;
  if (!random) {
    num = 95;
  } else {
    num = random;
  }
  return n1 > num ? false : true;
}

/**
 * des. 检查搜索的名称
 * added by Rorschach
 */
function checkName(val) {
  if (!val) {
    this.mathRandom(50)
      ? Toast.fail("请输入搜索内容 ~")
      : Modal.alert("You are so cute! (つω｀)～");
    return null;
  }

  if (val === "329") {
    Modal.alert("329 Never Die! （｀へ´）!!");
    return null;
  }

  const reg = /^\d+$/g;
  if (reg.test(val)) {
    this.mathRandom(80)
      ? Toast.fail("请输不要输数字呀~")
      : Modal.alert("You are so cute! (つω｀)～");
    return null;
  }

  return this.removeSpaces(val);
}

function isPC() {
  const userAgentInfo = navigator.userAgent;
  const Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  let flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
    }
  }
  return flag;
}
 function getConsistency() {
  let s = false;
  const p = xyStorage.getItem("nickname");
  if (!p) {
    return false;
  }
  consts.pList.forEach(e => (e == p ? (s = true) : false));
  return s ? true : false;
}

//判断奇偶性
function getParity() {
  const now = new Date();
  const time = now.getSeconds();
  if (time <= 52 || time % 2 === 0) {
    return true;
  } else {
    return false;
  }
  // if (this.isPC()) {
  //   return false;
  // } else {
  // }
}

function getItemOpenId() {
  const openid = xyStorage.getItem(xyStorage.KEYS.openid);
  if (!openid) {
    xyStorage.removeItem(xyStorage.KEYS.openid);
    return false;
  }
  return openid;
}
function setItemOpenId(openid) {
  xyStorage.setItem(xyStorage.KEYS.openid, openid);
}
function getItemRegisterCode() {
  const registerCode = xyStorage.getItem(xyStorage.KEYS.registerCode);
  if (!registerCode) {
    xyStorage.removeItem(xyStorage.KEYS.registerCode);
    return false;
  }
  return registerCode;
}
function setItemRegisterCode(registerCode) {
  xyStorage.setItem(xyStorage.KEYS.registerCode, registerCode);
}

function suffix(l, h, w) {
  return l + "/h/" + h + "/w/" + w;
}
function curry(fn, ...args) {
  return (..._arg) => {
    return fn(...args, ..._arg);
  };
}
const imageSuffix = curry(suffix, "?imageView2/1/q/100");

/* 柯里化 Currying check */
function check(reg) {
  return function(text) {
    return reg.test(text);
  };
}
/* 判断是否为手机号 */
const hasPhone = check(/^1[345789]\d{9}$/);
const hasPIN = check(/^\d{6}$/);

function isDebug() {
  return process.env.NODE_ENV !== "production";
}

/**
 * push到某个路由地址
 *
 * @param {string} url - 地址url
 * @param query
 * @returns {*}
 */
function pushUrl(url, query = {}) {
  if (isAbsoluteUrl(url)) {
    return (window.location.href = url);
  }
  return history.push(appendUrlQuery(url, query));
}

function goBack() {
  return history.go(-1);
}

/**
 * replace到某个路由地址
 *
 * @param {string} url - 地址url
 * @param query
 * @returns {*}
 */
function replaceUrl(url, query = {}) {
  if (isAbsoluteUrl(url)) {
    return window.location.replace(url);
  }
  // return history.replace(appendUrlQuery(url, query));
  return window.location.replace(appendUrlQuery(url, query));
}
function getRouteParams(props) {
  return props.match.params;
}
function appendUrlQuery(url, query = {}) {
  const parsedUrl = urlUtils.parse(url);
  const queryStringInUrl = parsedUrl.query || "";
  const combinedQuery = querystring.stringify({
    ...querystring.parse(queryStringInUrl),
    ...query
  });
  parsedUrl.search = combinedQuery ? `?${combinedQuery}` : "";
  return parsedUrl.format();
}

function getUrlQuery(url = window.location.href) {
  return querystring.parse(urlUtils.parse(url).query);
}

/**
 * 用户是否登录
 *
 * @returns {boolean}
 */
function isLogin() {
  const openid = xyStorage.getItem(xyStorage.KEYS.openid);
  if (!openid) {
    xyStorage.removeItem(xyStorage.KEYS.openid);
    return false;
  }
  return true;
}

function getLoginUrl(return_url) {
  return_url = return_url || consts.URL_INDEX;
  return appendUrlQuery(consts.URL_LOGIN, {
    return_url
  });
}

function isAtLoginPage() {
  return (
    window.location.pathname === consts.URL_LOGIN ||
    window.location.pathname === consts.URL_LOGIN + "/"
  );
}

function isAbsoluteUrl(url) {
  return /^[a-z][a-z0-9+.-]*:/.test(url);
}

function isLocalHost(hostname) {
  if (hostname === "localhost") {
    return true;
  }
  if (hostname === "127.0.0.1") {
    return true;
  }
  if (hostname === "0.0.0.0") {
    return true;
  }
  if (/^192\.168\.\d+\.\d+$/gi.test(hostname)) {
    return true;
  }

  return false;
}

function parseIdCard(cardNum) {
  let birth;
  let gender = consts.GENDER_VALS.UNKNOWN; // 0保密 1男 2女

  let age;

  if (cardNum.length < 18) {
    return {};
  }

  //获取出生日期
  birth =
    cardNum.substring(6, 10) +
    "-" +
    cardNum.substring(10, 12) +
    "-" +
    cardNum.substring(12, 14);

  //获取性别
  if (parseInt(cardNum.substr(16, 1), 10) % 2 === 1) {
    //男
    gender = consts.GENDER_VALS.MALE;
  } else {
    //女
    gender = consts.GENDER_VALS.FEMALE;
  }

  //获取年龄
  const myDate = new Date();
  const month = myDate.getMonth() + 1;
  const day = myDate.getDate();
  age = myDate.getFullYear() - cardNum.substring(6, 10) - 1;
  if (
    cardNum.substring(10, 12) < month ||
    (cardNum.substring(10, 12) === month && cardNum.substring(12, 14) <= day)
  ) {
    age++;
  }

  if (age < 0) {
    age = 0;
  }

  return {
    birth,
    gender,
    age
  };
}

function isChineseChar(str) {
  return /[^u4e00-u9fa5]/.test(str);
}

/* eslint-disable  */
function isIdCardValid(num) {
  num = num.toUpperCase();
  //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
  if (!/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num)) {
    // alert('输入的身份证号长度不对，或者号码不符合规定！\n15位号码应全为数字，18位号码末位可以为数字或X。');
    return false;
  }
  //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
  //下面分别分析出生日期和校验位
  var len, re;
  len = num.length;
  if (len == 15) {
    re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
    var arrSplit = num.match(re);

    //检查生日日期是否正确
    var dtmBirth = new Date(
      "19" + arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
    );
    var bGoodDay;
    bGoodDay =
      dtmBirth.getYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4]);
    if (!bGoodDay) {
      // alert('输入的身份证号里出生日期不对！');
      return false;
    } else {
      //将15位身份证转成18位
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var arrCh = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      var nTemp = 0,
        i;
      num = num.substr(0, 6) + "19" + num.substr(6, num.length - 6);
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      num += arrCh[nTemp % 11];
      return true;
    }
  }
  if (len == 18) {
    re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
    var arrSplit = num.match(re);

    //检查生日日期是否正确
    var dtmBirth = new Date(
      arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]
    );
    var bGoodDay;
    bGoodDay =
      dtmBirth.getFullYear() == Number(arrSplit[2]) &&
      dtmBirth.getMonth() + 1 == Number(arrSplit[3]) &&
      dtmBirth.getDate() == Number(arrSplit[4]);
    if (!bGoodDay) {
      // alert(dtmBirth.getYear());
      // alert(arrSplit[2]);
      // alert('输入的身份证号里出生日期不对！');
      return false;
    } else {
      //检验18位身份证的校验码是否正确。
      //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
      var valnum;
      var arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var arrCh = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      var nTemp = 0,
        i;
      for (i = 0; i < 17; i++) {
        nTemp += num.substr(i, 1) * arrInt[i];
      }
      valnum = arrCh[nTemp % 11];
      if (valnum != num.substr(17, 1)) {
        // alert('18位身份证的校验码不正确！'); //应该为： + valnum
        return false;
      }
      return true;
    }
  }
  return false;
}

/* eslint-enable  */

function getScrollTop(domElement) {
  if (
    domElement === window ||
    domElement === document ||
    domElement === document.body
  ) {
    return document.body.scrollTop;
  }
  return domElement.scrollTop;
}

function getScrollBottom(domElement) {
  if (
    domElement === window ||
    domElement === document ||
    domElement === document.body
  ) {
    return (
      document.body.scrollHeight - window.innerHeight - document.body.scrollTop
    );
  }
  return (
    domElement.scrollHeight - domElement.clientHeight - domElement.scrollTop
  );
}

/**
 * des. 去除空格
 * added by Rorschach
 */
function removeSpaces(str) {
  //去除前后
  return str.replace(/\s+/gi, "");
}

function appendScript(src) {
  const js = document.createElement("script");
  js.src = src;
  js.async = true;
  document.head.appendChild(js);
}

function isWeiXin() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /MicroMessenger/i.test(ua);
}

function clearUserLoginData() {
  window.xyStorage.clearAll();
}

function xorStrings(key, input) {
  if (typeof input !== "string") {
    input = JSON.stringify(input);
  }
  let output = "";
  for (let i = 0; i < input.length; i++) {
    const c = input.charCodeAt(i);
    const k = key.charCodeAt(i % key.length);
    output += String.fromCharCode(c ^ k);
  }
  return output;
}
const base64Encode = Base64.encode;
const base64Decode = Base64.decode;

export default {
  isDebug,
  pushUrl,
  replaceUrl,
  goBack,
  isLogin,
  getLoginUrl,
  isAtLoginPage,
  clearUserLoginData,
  appendUrlQuery,
  isAbsoluteUrl,
  isLocalHost,
  getUrlQuery,
  parseIdCard,
  isIdCardValid,
  isChineseChar,
  getScrollBottom,
  getScrollTop,
  removeSpaces,
  appendScript,
  isWeiXin,
  xorStrings,
  base64Encode,
  base64Decode,
  getRouteParams,
  hasPhone,
  hasPIN,
  qsStringify,
  noop,
  getItemOpenId,
  setItemOpenId,
  mathRandom,
  checkName,
  setItemRegisterCode,
  getItemRegisterCode,
  getParity,
  imageSuffix,
  isPC,
  getConsistency
};



// WEBPACK FOOTER //
// ./src/utils/utils.js